import { useEffect } from 'react';

import { initializeSnapEngage } from '.';

export const useSnapEngage = (): void => {
  useEffect(() => {
    initializeSnapEngage();
  }, []);
};
